<template>
    <div>
        <b-modal id="modal-Add-Slots" class="modal-form" title="Add Slots Agent" @hidden="CLEAR_FORM()" centered hide-footer>
            <b-row class="mb-4">
                <b-col md="7">
                    <div class="pb-1"><strong>Name :</strong> {{formdata.name}}</div>
                    <div class="pt-1 pb-1"><strong>Email :</strong> {{formdata.email}}</div>
                    
                </b-col>
                <b-col md="5">
                    <div class="pb-1"><strong>Total Events :</strong> {{formdata.events_count}} Event</div>
                    <div class="pt-1"><strong>Total Slots :</strong> {{formdata.slots}} Slot</div>
                </b-col>
            </b-row>

            <ValidationObserver ref="form">
                <validation-provider rules="required|min_value:1" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Slot</label>
                        <input v-model="slots" type="number" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                        <small>*Make sure you have enough slots, because they will be cut from your slots. Your Slot cannot Transfer Back to You from Agent, Make sure the value is right.</small>
                    </div>
                </validation-provider>

                <div class="button-modal text-right">
                    <button v-on:click="addSlotsAgent(formdata.id)" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Add Slots
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>

        <b-modal id="modal-Event-Agent" size="xl" class="modal-form" title="Agent Information" @hidden="CLEAR_DATA_EVENTS_AGENTS(), del_events = []" centered hide-footer>
            <b-row class="mb-4">
                <b-col md="6">
                    <div class="pb-1"><strong>Agent Name :</strong> {{events_agent.name}}</div>
                    <div class="pt-1"><strong>Email :</strong> {{events_agent.email}}</div>
                </b-col>
                <b-col md="6">
                    <div class="pb-1"><strong>Total Events :</strong> {{events_agent.events.length}} Event</div>
                    <div class="pt-1"><strong>Total Slots :</strong> {{events_agent.slots}} Slots</div>
                </b-col>
            </b-row>

            <h6 class="border-top pt-4 mb-3">List Event</h6>

            <div class="table-responsive bdr-15">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Date Event</th>
                            <th>Theme</th>
                            <th>Package</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="data in events_agent.events" :key="data.id" @click.prevent="detailEvents(data)">
                            <td v-on:click.stop="">
                                <b-dropdown id="dropdown-left" text="Settings" variant="primary" class="mt-2 mb-2">
                                    <template #button-content>
                                        Settings <i class="uil uil-angle-down"></i>
                                    </template>
                                    <b-dropdown-item target="_blank" :href="data | eventLink">Visit Event</b-dropdown-item>
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-dropdown-item href="#" @click.stop.prevent="copyBioLink(data.id)"><i class="uil uil-copy"></i> Copy Event Link</b-dropdown-item>
                                    <b-dropdown-item v-if="data.type === 'PREMIUM'" href="#" @click.stop.prevent="copyAnalyticsLink(data.id)"><i class="uil uil-copy"></i> Copy Event Analytics Link</b-dropdown-item>
                                </b-dropdown>

                                <input type="hidden" :id="'biolink' + data.id" :value="$options.filters.eventLink(data)">
                                <input type="hidden" :id="'analyticslink' + data.id" :value="$options.filters.analyticsLink(data)">
                            </td>
                            <td>{{data.id}}</td>
                            <td>{{data.title}}</td>
                            <td>{{data.date_event | formatDate}}</td>
                            <td>{{data.theme ? data.theme.name : '-'}}</td>
                            <td>
                                <div class="premium-label" v-if="data.type === 'PREMIUM'">{{data.type}}</div>
                                <div class="standard-label" v-if="data.type === 'STANDARD'">{{data.type}}</div>
                            </td>
                            <td width="100px">
                                <label v-if="data.status === 1" class="badge badge-success"><i class="uil uil-check"></i> Publish</label>
                                <label v-if="data.status === 0" class="badge badge-info"><i class="uil uil-hourglass"></i> On Progress</label>
                            </td>
                        </tr>
                    
                    </tbody>
                    
                </table>
                <p v-if="events_agent.events.length === 0" class="text-center no-data">Events data not found</p>
  
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import moment from 'moment'

    export default{
        data(){
            return{
                loading:false,
                slots:null,
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        watch:{
            errors:function(val){
                if(val === 'slot'){
                    this.$toast.warning('Your slots are not enough')
                    this.loading = false
                }
            }
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
            eventLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug
            },
            analyticsLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug + '/analytics?code=' + value.token_analytics
            },
        },
        computed: {
            ...mapState('AgentsControl', {
                formdata: state => state.formdata,
                events_agent: state => state.events_agent,
                errors: state => state.errors
            }),
        },
        methods: {
            ...mapActions('AgentsControl', ['updateSlotsAgentsDistributor']),
            ...mapMutations('AgentsControl', ['CLEAR_FORM','CLEAR_DATA_EVENTS_AGENTS']),
            ...mapActions('UsersControl', ['getProfile']),
            
            copyBioLink (id) {
                let bioLinkToCopy = document.querySelector('#biolink' + id)
                bioLinkToCopy.setAttribute('type', 'text')
                bioLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                bioLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            copyAnalyticsLink (id) {
                let AnalyticsLinkToCopy = document.querySelector('#analyticslink' + id)
                AnalyticsLinkToCopy.setAttribute('type', 'text')
                AnalyticsLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                AnalyticsLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            addSlotsAgent: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var form = {
                            slots: this.slots,
                            id: id
                        }
                        
                        this.updateSlotsAgentsDistributor(form).then(() => {
                            this.loading = false
                            this.$bvModal.hide('modal-Add-Slots')
                            this.$emit('getAgents');
                            this.getProfile()
                            this.slots = null
                            this.$toast.success('Successfully Updated Slots')
                        }) 
                    }
                });
            }
        }
    }
</script>
